import { gql } from '@apollo/client'

export const CHANGE_RESERVE_DETAILS_MUTATION = gql`
  mutation ChangeReserveDetails(
    $reservationNumber: String!
    $input: ChangeReserveDetailsInput!
  ) {
    changeReserveDetails(reservationNumber: $reservationNumber, input: $input) {
      message
    }
  }
`
